import { NOTIFICATION_TYPE_ENUM } from "interfaces";
import { observer } from "mobx-react-lite";
import { useNotificationContext } from "providers";

import { useStores } from "stores";
import { CustomButton } from "ui";
import { parseErrorMessage } from "utils";

export const ApproveAllRisksBtn = observer(() => {
  const { bidCard, bidTransactions, bidWalletChecks } = useStores();
  if (!bidCard.bid) return null;

  const fetchDataCheck = async (fn: () => Promise<any>, successMsg: string) => {
    try {
      await fn();
      openNotification({
        type: NOTIFICATION_TYPE_ENUM.SUCCESS,
        description: `Данные по ${successMsg} успешно обновлены`,
      });
    } catch (error: any) {
      openNotification({
        message: parseErrorMessage(error),
        type: NOTIFICATION_TYPE_ENUM.ERROR,
      });
    }
  };

  const { openNotification } = useNotificationContext();

  async function handleApproveRiskAll() {
    if (!bidCard.bid) return;

    try {
      await bidCard.approveAllRisks(bidCard.bid.id);
      setTimeout(() => {
        fetchDataCheck(bidTransactions.fetch, "транзакциям");
        fetchDataCheck(bidWalletChecks.fetch, "проверкам кошельков");
        bidCard.fetchCardById(bidCard.bid.id);
      }, 1500);
      openNotification({
        type: NOTIFICATION_TYPE_ENUM.SUCCESS,
        description: "Все риски успешно одобрены",
      });
    } catch (error: any) {
      openNotification({
        type: NOTIFICATION_TYPE_ENUM.ERROR,
        description: parseErrorMessage(error),
      });
    }
  }

  return (
    <CustomButton
      onClick={handleApproveRiskAll}
      type="primary"
      disabled={bidCard.approveAllStatuses.loading}
      loading={bidCard.approveAllStatuses.loading}
      tooltip="Вы можете согласовать риски всех существующих проверок по заявке"
    >
      Согласовать риски
    </CustomButton>
  );
});
